module.exports = __webpack_public_path__ + "img/img30.62cc2d96.svg";